import React, {SetStateAction, Dispatch} from "react";
import {useTranslation} from "react-i18next";
import Rider from "model/Rider";
import Button from "@awsui/components-react/button";
import {useMutation} from "react-query";
import saveLineups from "api/saveLineups";
import Competition from "model/Competition";
import {FlashbarProps, IconProps} from "@awsui/components-react";
import League from "model/League";
import {useAuth} from "hooks/useAuth";
import {MAX_BUDGET, TEAM_SIZE} from "common/const";


interface SubmitLineupsButtonProps {
    selectedRiders: Rider[];
    competition: Competition;
    league: League;
    buttonEnabled: boolean;
    setButtonEnabled: Dispatch<SetStateAction<boolean>>;
    buttonIconName: IconProps.Name | undefined;
    setButtonIconName: Dispatch<SetStateAction<IconProps.Name | undefined>>;
    setSubmitMessage: Dispatch<SetStateAction<FlashbarProps.MessageDefinition | undefined>>;
}

const SubmitLineupsButton: React.FC<SubmitLineupsButtonProps> = (props) => {

    const {t} = useTranslation(["lineup", "common", "errors"]);
    const selectedRiders = props.selectedRiders;
    const competition = props.competition;
    const league = props.league;

    const [{user}] = useAuth();

    const {
        isLoading: saveLineupsIsLoading,
        mutate: callSaveLineups
    } = useMutation(() => saveLineups(competition, league, selectedRiders, user?.token), {
        onSuccess: () => {
            props.setSubmitMessage({
                header: t("lineup:saveSuccess"),
                type: "success",
                content: "",
            });
            props.setButtonIconName("status-positive");
        },
        onError: () => {
            props.setSubmitMessage({
                header: t("errors:saveLineup"),
                type: "error",
                content: t("common:errors.tryAgain"),
            });
            props.setButtonIconName("status-negative");
        },
        onSettled: () => {
            props.setButtonEnabled(false);
        }
    });

    const saveRiders = () => {
        callSaveLineups();
    };

    const ridersValue: number = selectedRiders.length
        ? selectedRiders
            .map((item: { value: number; }) => item.value)
            .reduce((previousValue: number, currentValue: number) => previousValue + currentValue)
        : 0;

    return (
        <Button
            disabled={!props.buttonEnabled || (ridersValue > MAX_BUDGET || selectedRiders.length !== TEAM_SIZE)}
            iconAlign="left"
            iconName={props.buttonIconName}
            loading={saveLineupsIsLoading}
            variant="primary"
            onClick={saveRiders}
        >
            {t("common:buttons.save")}
        </Button>
    );
};

export default SubmitLineupsButton;
